import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Box,
  Typography,
  Rating,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  styled,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Radio as MuiRadio } from "@mui/material";

import { enqueueSnackbar } from "notistack";
import { feedback_api_by_web } from "../../DAL/partner/partners";
const GrayDisabledRadio = styled(MuiRadio)(({ theme }) => ({
  "&.Mui-disabled": {
    color: theme.palette.grey[500], // Gray color for disabled state
  },
}));

const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    width: "900px",
    maxWidth: "95vw",
    borderRadius: "12px",
    overflow: "hidden",
  },
});

const FeedBack = ({ openFeedback, setOpenFeedback, user }) => {
  console.log(user, "useruseruseruseruser");
  const [IsSubmitting, setIsSubmitting] = useState(false);
  const initial_values = {
    first_name: "",
    last_name: "",
    email: "",
    feedback_type: "",
    feedback: "",
    user_type: "",
    rating: 0,
  };
  const [formData, setFormData] = useState(initial_values);
  const [isUserTypeDisabled, setIsUserTypeDisabled] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRatingChange = (event, newValue) => {
    setFormData((prev) => ({ ...prev, rating: newValue }));
  };

  const handleCloseFeedback = () => {
    setOpenFeedback(false);
    setFormData(initial_values);
  };

  const handleSubmit = async () => {
    if (
      !formData.feedback_type ||
      !formData.feedback ||
      !formData.user_type ||
      !formData.rating
    ) {
      enqueueSnackbar("Please fill all required fields", { variant: "error" });
      return;
    }

    const postdata = {
      first_name: formData.first_name ? String(formData.first_name) : "",
      last_name: formData.last_name ? String(formData.last_name) : "",
      email: formData.email ? String(formData.email) : "",
      feedback_type: String(formData.feedback_type),
      feedback: String(formData.feedback),
      user_type: String(formData.user_type),
      rating: parseInt(formData.rating),
    };

    setIsSubmitting(true);
    const response = await feedback_api_by_web(postdata);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      handleCloseFeedback();
      setFormData(initial_values);
      setIsSubmitting(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (openFeedback && user?.type) {
      const userType = user.type === 1 ? "candidate" : "client";
      setFormData((prev) => ({
        ...prev,
        user_type: userType,
      }));
      setIsUserTypeDisabled(true); // Disable the radio buttons when user type is pre-selected
    } else {
      setIsUserTypeDisabled(false); // Enable radio buttons when no user type is provided
    }
  }, [openFeedback, user]);

  return (
    <StyledDialog
      open={openFeedback}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        handleCloseFeedback();
      }}
    >
      <DialogTitle className="dialog-title">
        <Typography
          variant="h5"
          fontWeight={700}
          letterSpacing={1}
          className="dialog-title-text"
        >
          We Value Your Feedback!
        </Typography>
        <IconButton
          onClick={handleCloseFeedback}
          className="dialog-close-button"
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className="dialog-content">
        <Box className="info-box">
          <Typography
            variant="body1"
            gutterBottom
            className="dialog-content-text"
          >
            We welcome your feedback! Share your thoughts, suggestions, or
            concerns to help us make your experience even better.
          </Typography>
        </Box>

        {/* User Type */}
        <FormControl component="fieldset" className="form-control-fieldset">
          <FormLabel component="legend" className="form-control-label">
            You are <span style={{ color: "#d32f2f" }}>*</span>
          </FormLabel>
          <RadioGroup
            row
            name="user_type"
            value={formData.user_type}
            onChange={handleChange}
            className="radio-group"
          >
            <FormControlLabel
              value="client"
              control={
                <Radio
                  disabled={isUserTypeDisabled}
                  sx={{
                    color: isUserTypeDisabled ? "#9e9e9e" : "default",
                    "&.Mui-checked": {
                      color: isUserTypeDisabled ? "#9e9e9e" : "#1976d2",
                    },
                  }}
                />
              }
              label={
                <Typography
                  fontSize="1rem"
                  sx={{ color: isUserTypeDisabled ? "#9e9e9e" : "inherit" }}
                >
                  Client
                </Typography>
              }
              disabled={isUserTypeDisabled}
            />

            <FormControlLabel
              value="candidate"
              control={
                <Radio
                  disabled={isUserTypeDisabled}
                  sx={{
                    color: isUserTypeDisabled ? "#9e9e9e" : "default",
                    "&.Mui-checked": {
                      color: isUserTypeDisabled ? "#9e9e9e" : "#1976d2",
                    },
                  }}
                />
              }
              label={
                <Typography
                  fontSize="1rem"
                  sx={{ color: isUserTypeDisabled ? "#9e9e9e" : "inherit" }}
                >
                  Candidate
                </Typography>
              }
              disabled={isUserTypeDisabled}
            />
          </RadioGroup>
        </FormControl>

        {/* Rest of your component remains the same... */}
        {/* Feedback Type */}
        <FormControl component="fieldset" className="form-control-fieldset">
          <FormLabel component="legend" className="form-control-label">
            Feedback Type <span style={{ color: "#d32f2f" }}>*</span>
          </FormLabel>
          <RadioGroup
            row
            name="feedback_type"
            value={formData.feedback_type}
            onChange={handleChange}
            className="radio-group"
          >
            <FormControlLabel
              value="comment"
              control={<Radio className="radio-button" />}
              label={<Typography fontSize="1rem">Comments</Typography>}
            />
            <FormControlLabel
              value="suggestion"
              control={<Radio className="radio-button" />}
              label={<Typography fontSize="1rem">Suggestions</Typography>}
            />
            <FormControlLabel
              value="question"
              control={<Radio className="radio-button" />}
              label={<Typography fontSize="1rem">Questions</Typography>}
            />
          </RadioGroup>
        </FormControl>

        {/* Feedback Text */}
        <FormControl fullWidth className="form-control-full-width">
          <FormLabel className="form-control-label">
            Describe Your Feedback <span style={{ color: "#d32f2f" }}>*</span>
          </FormLabel>
          <TextField
            name="feedback"
            multiline
            minRows={4}
            value={formData.feedback}
            onChange={handleChange}
            placeholder="Type your feedback here..."
            variant="outlined"
            className="text-field"
          />
        </FormControl>

        {/* Rating */}
        <Box className="rating-box">
          <FormLabel className="form-control-label">
            How would you rate your experience?{" "}
            <span style={{ color: "#d32f2f" }}>*</span>
          </FormLabel>
          <Rating
            name="rating"
            value={formData.rating}
            onChange={handleRatingChange}
            size="large"
            className="rating-star"
          />
        </Box>

        {/* Anonymous Info Box */}
        <Box className="info-box">
          <Typography className="feedback-info-text">
            Providing your name and email is optional — your feedback can be
            submitted anonymously, and your information will be kept
            confidential.{" "}
          </Typography>
        </Box>

        {/* Name Fields */}
        <Box className="name-fields-box">
          <FormControl fullWidth className="form-control-full-width">
            <FormLabel className="form-control-label">First Name</FormLabel>
            <TextField
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="First Name"
              variant="outlined"
              className="text-field"
            />
          </FormControl>
          <FormControl fullWidth className="form-control-full-width">
            <FormLabel className="form-control-label">Last Name</FormLabel>
            <TextField
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Last Name"
              variant="outlined"
              className="text-field"
            />
          </FormControl>
        </Box>

        {/* Email Field */}
        <FormControl fullWidth className="email-field-control">
          <FormLabel className="form-control-label">E-mail</FormLabel>
          <TextField
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="ex: myname@example.com"
            variant="outlined"
            className="text-field"
          />
        </FormControl>
      </DialogContent>

      {/* Footer with Submit Button */}
      <DialogActions className="dialog-actions">
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={
            !formData.feedback_type ||
            !formData.feedback ||
            !formData.user_type ||
            !formData.rating
          }
          className="submit-button"
        >
          {IsSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default FeedBack;
